import { useQuery } from '@tanstack/react-query';
import { fetchCohorts } from '@/lib/cohorts.ts';
import { fetchTracks } from '@/lib/tracks.ts';

/**
 * The tracks and cohorts a gesprekstype can be aimed at. Only whoever keeps
 * the organisation's templates can aim one, and those endpoints are theirs
 * alone, so nothing is asked for anybody else.
 */
export function useMeetingTemplateAudiences(
  organisationId: string | undefined,
  keepsOrganisation: boolean,
) {
  const enabled = keepsOrganisation && organisationId !== undefined;

  const { data: cohorts = [] } = useQuery({
    queryKey: ['cohorts', organisationId],
    queryFn: () => fetchCohorts(organisationId!),
    enabled,
  });
  const { data: tracks = [] } = useQuery({
    queryKey: ['tracks', organisationId],
    queryFn: () => fetchTracks(organisationId!),
    enabled,
  });

  return { cohorts, tracks };
}
